import React, { useEffect, useRef } from 'react'
import AgentChat from '../AgentChat/AgentChat'

/**
 * 「我的课程」右侧常驻导览员：完整复用 AgentChat guide 变体。
 */
export default function PortalGuidePanel({
  agent,
  user,
  expertServiceUrl,
  welcomeContentOverride,
  guideDocLinks,
  onA2UIAction,
  spotlight = false,
  focusToken = 0,
}) {
  const dockRef = useRef(null)

  useEffect(() => {
    if (!focusToken || !dockRef.current) return
    dockRef.current.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' })
    dockRef.current.focus({ preventScroll: true })
  }, [focusToken])

  if (!agent || !user) return null

  return (
    <aside
      ref={dockRef}
      className={`portal-guide-dock${spotlight ? ' is-spotlight' : ''}`}
      aria-label="邮百工导览员"
      tabIndex={-1}
    >
      <div className="portal-guide-dock-inner">
        <AgentChat
          agent={agent}
          user={user}
          expertServiceUrl={expertServiceUrl}
          welcomeContentOverride={welcomeContentOverride}
          onA2UIAction={onA2UIAction}
          projectName="入场导览"
          variant="guide"
          guideDocLinks={guideDocLinks}
        />
      </div>
    </aside>
  )
}
